"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfTableExporter = void 0;
var rtf_nested_table_exporter_state_1 = require("./states/rtf-nested-table-exporter-state");
var rtf_table_exporter_state_1 = require("./states/rtf-table-exporter-state");
var RtfTableExporter = (function () {
    function RtfTableExporter() {
    }
    RtfTableExporter.exportTable = function (rtfContentExporter, table) {
        new rtf_table_exporter_state_1.RtfTableExporterState(rtfContentExporter, table).export();
        rtfContentExporter.tableIterator.update(table.getEndPosition());
        return rtfContentExporter.subDocument.getParagraphIndexByPosition(table.getEndPosition() - 1);
    };
    RtfTableExporter.exportNestedTable = function (rtfContentExporter, table, nestingLevel) {
        new rtf_nested_table_exporter_state_1.RtfNestedTableExporterState(rtfContentExporter, table, nestingLevel).export();
        rtfContentExporter.tableIterator.update(table.getEndPosition());
        return rtfContentExporter.subDocument.getParagraphIndexByPosition(table.getEndPosition() - 1);
    };
    return RtfTableExporter;
}());
exports.RtfTableExporter = RtfTableExporter;
